import { render, staticRenderFns } from "./FormDatepickerValidation.vue?vue&type=template&id=8533d48c&"
import script from "./FormDatepickerValidation.vue?vue&type=script&lang=js&"
export * from "./FormDatepickerValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports